import SignOutButton from './SignOutButton';
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOutWebsite } from '../utils/signOut';
import { dashboardNavigation } from './external/dashboardNavigation';

const NAV_GROUPS = dashboardNavigation.TENANT.map(group => group.items.map(item => ({
  to: item.path, label: item.label, icon: item.icon, matchPrefix: item.matchPrefix,
})));
function isActive(path: string, hash: string, to: string, matchPrefix?: boolean) {
  if (to.includes('#kyc')) return path === '/tenant/profile' && hash === '#kyc';
  if (to === '/tenant/profile') return path === '/tenant/profile' && hash !== '#kyc';
  if (matchPrefix) return path === to || path.startsWith(`${to}/`);
  return path === to;
}

interface TenantSidebarProps {
  unreadNotifications?: number;
  referralEnabled?: boolean;
}

export default function TenantSidebar({ unreadNotifications = 0, referralEnabled = false }: TenantSidebarProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const current = location.pathname;
  const hash = location.hash;

  const handleLogout = async () => {
    await signOutWebsite();
    navigate('/');
  };

  const badgeFor = (to: string) => {
    if (to === '/tenant/notifications' && unreadNotifications > 0) return unreadNotifications;
    return undefined;
  };

  return (
    <nav className="srs-tenant-sidebar-panel" aria-label="Tenant navigation">
      <div className="srs-tenant-nav-scroll">
      {NAV_GROUPS.map((group, gi) => (
        <div key={gi} className={gi > 0 ? 'srs-tenant-nav-group-divider' : undefined}>
          <ul className="srs-tenant-nav-list">
            {group.filter(item => item.to !== '/tenant/referrals' || referralEnabled).map((item) => {
              const active = isActive(current, hash, item.to, item.matchPrefix);
              const badge = badgeFor(item.to);
              return (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className={`srs-tenant-nav-link${active ? ' is-active' : ''}`}
                    aria-current={active ? 'page' : undefined}
                  >
                    <i className={`fa-solid ${item.icon}`} aria-hidden />
                    <span className="srs-tenant-nav-label">{item.label}</span>
                    {badge != null && badge > 0 && (
                      <span className="srs-tenant-nav-badge">{badge > 9 ? '9+' : badge}</span>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
      </div>
      <div className="srs-tenant-nav-group-divider srs-tenant-nav-logout-wrap">
        <SignOutButton className="srs-tenant-nav-link srs-tenant-nav-logout" onSignOut={handleLogout} />
      </div>
    </nav>
  );
}

